type FirebaseConfig = {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
};

const ENV_NAME = process.env.REACT_APP_ENV;

export const ENV = {
  name: ENV_NAME,
  isDevelopment: ENV_NAME === 'development',
  isProduction: ENV_NAME === 'production',

  api: {
    dev: process.env.REACT_APP_API_DEV || '',
    prod: process.env.REACT_APP_API_PROD || '',
  },

  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
  },

  stripeKey: ENV_NAME === 'production' ? process.env.REACT_APP_STRIPE_LIVE_KEY || '' : process.env.REACT_APP_STRIPE_TEST_KEY || '',
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY || '',
  // Helper method to get the correct Firebase config
  getFirebaseConfig(): FirebaseConfig {
    return this.firebase;
  }
};
